import { useNavigate } from "react-router-dom"

const Tableinventario = ({ datos }) => {
    const navigate = useNavigate()

    const handleRowClick = (codigo) => {
        navigate(`${codigo}`)
    }

    return (
        <div className="table-responsive">
            <table className="table table-hover table-sm w-100 mb-0 small">
                <thead className="">
                    <tr>
                        {/* Imagen oculta en móviles */}
                        <th className="align-middle text-center p-1 d-none d-md-table-cell">Imagen</th>
                        {/* Unidad Prestadora y Servicio ocultos en móviles */}
                        <th className="align-middle text-center p-1 d-none d-md-table-cell">Unidad Prestadora</th>
                        <th className="align-middle text-center p-1 d-none d-md-table-cell">Servicio</th>
                        <th className="align-middle text-center p-1">Nombre del Equipo</th>
                        <th className="align-middle text-center p-1">Cod.Patrimonial</th>
                        <th className="align-middle text-center p-1">Marca / Modelo</th>
                        <th className="align-middle text-center p-1" style={{ width: "6%" }}>Estado</th>
                    </tr>
                </thead>
                <tbody>
                    {datos.res.map((equipo) => (
                        <tr
                            key={equipo.co}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleRowClick(equipo.co)}
                        >
                            {/* Imagen */}
                            <td className="align-middle text-center p-0 d-none d-md-table-cell">
                                <img
                                    src={`${process.env.REACT_APP_URL_IMG}/miniatura/${equipo.im?.[0]?.ni}`}
                                    alt="Imagen"
                                    style={{ width: "50px", height: "40px", objectFit: "cover" }}
                                    className="rounded border"
                                />
                            </td>
                            {/* Unidad Prestadora y Servicio */}
                            <td className="align-middle text-center p-1 d-none d-md-table-cell">{equipo.uP?.toUpperCase()}</td>
                            <td className="align-middle text-center p-1 d-none d-md-table-cell">{equipo.sr?.toUpperCase()}</td>
                            {/* Nombre del Equipo */}
                            <td className="align-middle text-center text-info font-weight-bold p-1">{equipo.de?.toUpperCase()}</td>
                            {/* Código Patrimonial */}
                            <td className="align-middle text-center text-info font-weight-bold p-1">{equipo.co}</td>
                            {/* Marca / Modelo */}
                            <td className="align-middle text-center p-1">
                                {equipo.ma} / {equipo.mo}
                            </td>
                            {/* Estado */}
                            <td className={`align-middle text-center px-1 py-0 small`}>
                                <div className={`d-block w-100 py-1 px-2 bg-${equipo.Cs} small font-weight-bold`}>
                                    {equipo.es?.toUpperCase()}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default Tableinventario
